module.exports = __webpack_public_path__ + "static/media/course_sample.87bc65c0.svg";